import ApiClient from './ApiClient';

class AgentNotes extends ApiClient {
  constructor() {
    super('notes', { accountScoped: true });
    this.agentId = null;
  }

  get url() {
    return `${this.baseUrl()}/agents/${this.agentId}/notes`;
  }

  get(agentId) {
    this.agentId = agentId;
    return super.get();
  }

  create(agentId, content) {
    this.agentId = agentId;
    return super.create({ content });
  }

  delete(agentId, id) {
    this.agentId = agentId;
    return super.delete(id);
  }
}

export default new AgentNotes();
